import {Pill} from '@hm/fundamental'
import {mdiCheckBold} from '@mdi/js'
import React, {useState} from 'react'

type PillWithTooltipProps = {
  tooltipValue: string
  pillValue: string
}

export const PillWithTooltip = ({pillValue, tooltipValue}: PillWithTooltipProps) => {
  const [showTooltip, setShowTooltip] = useState(false)

  return (
    <div
      className="inline-block relative cursor-pointer"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <Pill text={pillValue} type="primary" labelIcon={mdiCheckBold} />
      {showTooltip && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1.5 bg-gray-800 text-white rounded text-xs whitespace-nowrap z-50 shadow-lg pointer-events-none">
          {tooltipValue}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-800" />
        </div>
      )}
    </div>
  )
}
